<app-field-renderer
  [form]="form"
  [roles]="roleColors"
  [isRoleEditable]="isRoleEditable"
  [boundsRef]="boundsRef"
  [inBounds]="inBounds"
  [offsetRect]="offsetRect"
  [zoomScale]="zoomScale"
  resizableEdges=""
  [disableCustomFont]="disableCustomFont"
  [role2ColorMapping]="role2ColorMapping"
  (afterMove)="onMove()"
  (afterResize)="onResize()"
  (remove)="onRemove($event)"
  (roleChange)="onRoleChange($event)"
>
  <ng-container class="title">
    <i class="far fa-check-square mr-2"></i> <ng-container i18n>Checkbox</ng-container>
  </ng-container>
  <ng-container class="label">
    <i class="far fa-square checkbox-icon" draggable="false"></i>
  </ng-container>
</app-field-renderer>
